import apiService from '../apiService';

const referralService = {
    async updateReferral(payload, id) {
        try {
            const response = await apiService.patch(`/referral-request-update/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async createReffralContact(payload, id) {
        try {
            const response = await apiService.post(`/referral-contact`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async createRefferedAttorneyContact(id) {
        try {
            const response = await apiService.post(`/create-contact-referral/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


    async createAttorneyRequest(payload) {
        try {
            const response = await apiService.post(`/referral-request`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    
};
export default referralService;